import api from '../request';
const homeService = {
    // 获取资讯明细
    getNewsDetail(url, params) {
        return api.get(url, params);
    }
}
export default homeService;